import { useState, useEffect, useCallback } from "react";

export function useAppModals() {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [docsOpen, setDocsOpen] = useState(false);
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [stopConfirmOpen, setStopConfirmOpen] = useState(false);

  const [savedSummaryModalData, setSavedSummaryModalData] = useState<{
    meeting: any;
    summaryText: string;
    htmlFilename: string;
  } | null>(null);

  const closeAll = useCallback(() => {
    setDocsOpen(false);
    setSettingsOpen(false);
    setSummaryOpen(false);
    setProfileOpen(false);
    setHistoryOpen(false);
    setStopConfirmOpen(false);
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        closeAll();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [closeAll]);

  const openSavedSummary = useCallback((meeting: any, summaryText: string, htmlFilename?: string) => {
    setSavedSummaryModalData({ meeting, summaryText, htmlFilename: htmlFilename || "" });
    setSummaryOpen(true);
  }, []);

  const closeSummary = useCallback(() => {
    setSummaryOpen(false);
    setSavedSummaryModalData(null);
  }, []);

  return {
    settingsOpen, setSettingsOpen,
    docsOpen, setDocsOpen,
    summaryOpen, setSummaryOpen,
    profileOpen, setProfileOpen,
    historyOpen, setHistoryOpen,
    stopConfirmOpen, setStopConfirmOpen,
    savedSummaryModalData,
    openSavedSummary,
    closeSummary,
    closeAll
  };
}
